// extracted by mini-css-extract-plugin
module.exports = {"svg":"NtU9e","path":"cMX4u","svg--dark":"_0BsoZ"};